'use client';
import { Box, Divider } from '@mui/material';
import { ReactNode } from 'react';
import Logo from '../logo/Logo';
import FooterWave from './FooterWave';
import { darkModeColors, pxToRem } from '../../useClientImport';

type PageFooterProps = {
  children?: ReactNode;
  genericInfo?: ReactNode;
  hideLogo?: boolean;
  colorLogo?: boolean;
  bigLogo?: boolean;
  maxWidth?: number;
};

const PageFooter = ({
  children,
  hideLogo,
  colorLogo,
  bigLogo,
  genericInfo,
  maxWidth,
}: PageFooterProps) => {
  const contentPadding = { px: 0, py: 4 };
  return (
    <Box>
      <FooterWave />
      <Box
        sx={{
          width: '100%',
          backgroundColor: 'background.default',
        }}
      >
        <Box
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: darkModeColors.primary.dark,
            color: darkModeColors.text.primary,
          })}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: { xs: 'center', md: 'left' },
              py: { xs: 8, md: 2 },
              px: 2,
              mx: 'auto',
              width: '100%',
              maxWidth,
            }}
          >
            <Box
              sx={{
                textAlign: 'left',
                flexGrow: { md: 1 },
                ...contentPadding,
              }}
            >
              {children}
            </Box>
            {genericInfo ? (
              <Divider
                sx={(theme) => ({
                  background: darkModeColors.divider,
                  borderWidth: 1,
                })}
              />
            ) : null}
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexGrow: { md: 1 },
                  flexDirection: 'column',
                  textAlign: 'left',
                  ...contentPadding,
                }}
              >
                {genericInfo ? <Box>{genericInfo}</Box> : null}
              </Box>
              {!hideLogo && (
                <Box
                  sx={{
                    ml: { xs: 0, lg: 'auto' },
                    mr: 0,
                  }}
                >
                  <Logo
                    size={bigLogo ? pxToRem(138) : undefined}
                    textColor={darkModeColors.text.primary}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PageFooter;
